import { cx } from '@vizit/theme';
import { ModalOverlay, type ModalOverlayProps } from 'react-aria-components';

function DialogOverlay(props: ModalOverlayProps) {
  const { className, isDismissable = true, ...other } = props;

  return (
    <ModalOverlay
      className={cx(
        className,
        'fixed inset-0 z-50 bg-overlay/75 filter backdrop-blur data-[exiting]:duration-300 data-[entering]:animate-in data-[exiting]:animate-out data-[entering]:fade-in-0 data-[exiting]:fade-out-0',
      )}
      isDismissable={isDismissable}
      {...other}
    />
  );
}

export { DialogOverlay };
